// src/News.jsx
import React, { useState, useEffect, useRef } from "react";
import Header from "./Header"; // 필요한 경우
import axios from "axios";

import "../css/news.css"; // 기존에 사용하던 news.css
import Footer from "./Footer";

// 기본 뉴스 데이터 (서버에서 가져오지 못할 때 사용)
const defaultNewsData = [
        {
            id: 13,
            title: "투명하고 똑똑한 IT 건축 플랫폼 '프롭메이트' 부동산 개발의 새로운 패러다임 열다",
            url: 'http://www.powerkoreadaily.com/news/articleView.html?idxno=526686',
            thumbnail: 'https://picksell-test.s3.ap-northeast-2.amazonaws.com/propmate-image/news/1760945963090-821021998.png',
            category: 'NEWS',
            publishedAt: '2024-01-01T00:00:00.000Z'
        },
        {
            id: 14,
            title: "프롭메이트, '2024 대한민국 지식재산대전'에서 AI 토지정보 제공 시스템 선봬",
            url: 'https://www.gokorea.kr/news/articleView.html?idxno=817698',
            thumbnail: 'https://picksell-test.s3.ap-northeast-2.amazonaws.com/propmate-image/news/1760946542621-921395868.png',
            category: 'NEWS',
            publishedAt: '2024-01-02T00:00:00.000Z'
        },
        {
            id: 15,
            title: "프롭메이트, 'NIPA 지역 성과보고회' 성공적 참여",
            url: 'https://www.woodkorea.co.kr/news/articleView.html?idxno=82766',
            thumbnail: 'https://picksell-test.s3.ap-northeast-2.amazonaws.com/propmate-image/news/1760946574989-648140265.png',
            category: 'NEWS',
            publishedAt: '2024-01-03T00:00:00.000Z'
        },
        {
            id: 18,
            title: '프롭메이트, AIoT 국제전시회에서 혁신적 솔루션을 선보이다.',
            url: 'https://www.getnews.co.kr/news/articleView.html?idxno=700019',
            thumbnail: 'https://picksell-test.s3.ap-northeast-2.amazonaws.com/propmate-image/news/1760946695681-913414470.jpg',
            category: 'NEWS',
            publishedAt: '2024-01-04T00:00:00.000Z'
        },
        {
            id: 17,
            title: '프롭메이트, 2024 AIoT 국제전시회 참가... 토지 정보 제공 시스템·3D 가상 시뮬레이션 기술 알린다',
            url: 'https://kr.aving.net/news/articleView.html?idxno=1795022',
            thumbnail: 'https://picksell-test.s3.ap-northeast-2.amazonaws.com/propmate-image/news/1760946658077-917552308.jpg',
            category: 'NEWS',
            publishedAt: '2024-01-05T00:00:00.000Z'
        }
];

export default function News(props) {
    // 뉴스 데이터를 서버에서 가져오도록 수정
    const [newsData, setNewsData] = useState([]);
    const [loading, setLoading] = useState(true);

    // 가로 스크롤 관련 ref & 상태
    const containerRef = useRef(null);
    const [blockStep, setBlockStep] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const [lastWheelTime, setLastWheelTime] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 780);
    const throttleDelay = 300;

    // 서버에서 뉴스 데이터 가져오기
    useEffect(() => {
        const fetchNews = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER || 'http://localhost'}/api/news`, {
                    params: {
                        category: 'NEWS',
                        limit: 20
                    }
                });

                if (response.data.success && response.data.data && response.data.data.length > 0) {
                    // 날짜 역순 정렬 (publishedAt이 최신순)
                    const sorted = response.data.data.sort(
                        (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
                    );
                    console.log(sorted);
                    setNewsData(sorted);
                } else {
                    // 서버에서 데이터가 없거나 빈 배열일 때 기본 뉴스 사용
                    console.log('서버에서 뉴스 데이터가 없어 기본 뉴스를 표시합니다.');
                    setNewsData(defaultNewsData);
                }
            } catch (err) {
                console.error('뉴스 데이터 로딩 오류:', err);
                // 에러 발생 시 기본 뉴스 사용
                console.log('서버 연결 실패로 기본 뉴스를 표시합니다.');
                setNewsData(defaultNewsData);
            } finally {
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    // -- 가로 스크롤 계산
    // 각 뉴스 컬럼 너비(27vw) + 컬럼 간격(3vw) = 30vw
    function getBlockStep() {
        return (window.innerWidth * 30) / 100; // 30vw → px
    }

    // 현재 인덱스에 따라 버튼 활성화 여부 계산
    const totalColumns = Math.ceil(newsData.length / 2);
    const canGoPrev = currentIndex > 0;
    const canGoNext = currentIndex < totalColumns - 1;

    // 화살표 버튼 핸들러
    const handlePrevClick = () => {
        if (canGoPrev) {
            const newIndex = currentIndex - 1;
            setCurrentIndex(newIndex);
            scrollToIndex(newIndex);
        }
    };

    const handleNextClick = () => {
        if (canGoNext) {
            const newIndex = currentIndex + 1;
            setCurrentIndex(newIndex);
            scrollToIndex(newIndex);
        }
    };

    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    function animateScrollTo(rawTarget, duration = 300) {
        setIsAnimating(true);
        if (!containerRef.current) return;
        const container = containerRef.current;

        const start = container.scrollLeft;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const target = Math.max(0, Math.min(rawTarget, maxScrollLeft));
        const distance = target - start;
        const startTime = performance.now();

        function step(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easedValue = easeInOutQuad(progress);

            container.scrollLeft = start + distance * easedValue;
            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                container.scrollLeft = target;
                setIsAnimating(false);
            }
        }
        requestAnimationFrame(step);
    }

    function scrollToIndex(index, useAnimation = true) {
        const target = index * blockStep;
        if (useAnimation) animateScrollTo(target, 300);
        else if (containerRef.current) {
            containerRef.current.scrollLeft = target;
        }
    }

    // 마우스 휠 → 좌우 스크롤
    function handleWheel(e) {
        e.preventDefault();
        if (isAnimating) return;

        const now = Date.now();
        if (now - lastWheelTime < throttleDelay) return;
        setLastWheelTime(now);

        // 2행 → 컬럼 수 = (newsData.length / 2)
        const totalColumns = Math.ceil(newsData.length / 2);

        if (e.deltaY > 0 && currentIndex < totalColumns - 1) {
            const newIndex = currentIndex + 1;
            setCurrentIndex(newIndex);
            scrollToIndex(newIndex);
        } else if (e.deltaY < 0 && currentIndex > 0) {
            const newIndex = currentIndex - 1;
            setCurrentIndex(newIndex);
            scrollToIndex(newIndex);
        }
    }

    // 스크롤 위치 변경 감지하여 currentIndex 업데이트
    function handleScroll() {
        if (!containerRef.current) return;
        const container = containerRef.current;
        const scrollLeft = container.scrollLeft;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        const totalColumns = Math.ceil(newsData.length / 2);

        // 오른쪽 끝에 가까우면 (5px 이내) 마지막 인덱스로 처리
        let calculatedIndex;
        if (scrollLeft >= maxScrollLeft - 5) {
            calculatedIndex = totalColumns - 1;
        } else if (scrollLeft <= 5) {
            calculatedIndex = 0;
        } else {
            // 스크롤 위치를 기반으로 인덱스 계산
            calculatedIndex = Math.round(scrollLeft / blockStep);
        }

        // 최대 인덱스 제한
        const validIndex = Math.max(0, Math.min(calculatedIndex, totalColumns - 1));

        if (validIndex !== currentIndex) {
            setCurrentIndex(validIndex);
        }
    }

    // 창 크기 변화 시 blockStep 재계산
    useEffect(() => {
        function onResize() {
            setBlockStep(getBlockStep());
            setIsMobile(window.innerWidth <= 780);
            scrollToIndex(0, false);
            setCurrentIndex(0);
        }
        onResize(); // 초기 실행
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // 휠 이벤트 등록
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        // 모바일은 세로 스크롤
        if (window.innerWidth <= 1199) return;

        container.addEventListener("wheel", handleWheel, { passive: false });
        return () => container.removeEventListener("wheel", handleWheel);
        // eslint-disable-next-line
    }, [newsData, currentIndex, blockStep, isAnimating, lastWheelTime]);

    // 스크롤 이벤트 등록하여 실제 스크롤 위치에 따라 currentIndex 업데이트
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        // 모바일 스크롤 이벤트 제외
        if (window.innerWidth <= 1199) return;

        container.addEventListener("scroll", handleScroll);
        return () => container.removeEventListener("scroll", handleScroll);
        // eslint-disable-next-line
    }, [newsData, blockStep]);

    return (
        <>
            <div id="news">
                {/* 헤더 (필요하면 사용, 그렇지 않다면 제거) */}
                <Header userInfo={props.userInfo} logout={props.logout} />

                <section className="news-sectionwrap">

                    {/* 오른쪽 목록 */}
                    <div id="newsRight">
                        {loading ? (
                            <div style={{ textAlign: 'center', padding: '50px' }}>
                                <p>뉴스를 불러오는 중...</p>
                            </div>
                        ) : newsData.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '50px' }}>
                                <p>등록된 뉴스가 없습니다.</p>
                            </div>
                        ) : (
                            <>

                                {/* 좌우 화살표 버튼 */}
                                {!isMobile && (
                                    <>
                                        <button
                                            className="scroll-arrow arrow-left"
                                            onClick={handlePrevClick}
                                            disabled={!canGoPrev}
                                        >
                                            <img src={process.env.PUBLIC_URL + "images/news_arrow_left.png"} alt="이전" />
                                        </button>
                                        <button
                                            className="scroll-arrow arrow-right"
                                            onClick={handleNextClick}
                                            disabled={!canGoNext}
                                        >
                                            <img src={process.env.PUBLIC_URL + "images/news_arrow_right.png"} alt="다음" />
                                        </button>
                                    </>
                                )}

                                <div id="container" ref={containerRef}>
                                    {/* 2행 그리드 (desktop), flex-wrap(mobile)은 CSS에서 처리 */}
                                    <ul id="newsList">
                                        {newsData.map((item, idx) => (
                                            <li key={item.id || idx} className="news-item">
                                                <a
                                                    href={item.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <div className="contentsWrap">
                                                        <img
                                                            className="bgimg"
                                                            src={item.thumbnail || process.env.PUBLIC_URL + "images/news_default_image.png"}
                                                            alt={item.title}
                                                            onError={(e) => {
                                                                e.target.src = process.env.PUBLIC_URL + "images/news_default_image.png";
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="news_info_wrap">
                                                        <div className="news_title">
                                                            {item.title}
                                                        </div>
                                                        <div className="news_date">
                                                            {item.publishedAt ? item.publishedAt.split('T')[0] : ''}
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </>

                        )}
                    </div>
                </section>
                    <div></div>
            </div>
        </>
    );
}
